/* Serial Seal — CUSTOM GRADING TAG builder (/pages/tag-builder).
 *
 * Six steps on one state object, phone first: CARD -> GRADE -> BRAND ->
 * DESIGN -> PACK -> REVIEW. The live preview at the top re-renders through
 * gt-tag.js on every edit — the SAME renderer the cart and the press use, so
 * what the customer approves is what ships.
 *
 * COMPLETELY SEPARATE from the Security Seal builder. This file shares its
 * INFRASTRUCTURE (the upload Worker, the rush ladder semantics, the cart
 * endpoints) and none of its state or DOM. sv-builder.js is not loaded here.
 *
 * A PACK IS NOT N IDENTICAL COPIES. st.tags is a list of unique designs, each
 * with its own quantity; checkout is gated on sum(q) == pack size. Duplicate
 * exists precisely so a 24-tag order is "duplicate, change two fields" twelve
 * times rather than twelve builds.
 *
 * MONEY RULES (house): every displayed figure derives from the variant price
 * Shopify will actually charge — per-tag = price/qty rounded to the cent,
 * computed, never typed. The rush fee reuses the Skip the Production Line
 * ladder over the WHOLE cart's label count (seals x 12 + tags), same
 * anti-gaming semantics as sv-builder.js's rushPlan.
 */
(function () {
  'use strict';
  var CFG = window.GT_CFG || {};
  var PAGE_BOTTOM_PAD = true;

  /* ── packs, from the variants Shopify actually sells ── */
  function skuQty(sku) { var m = /SVN-TAG-(\d+)/.exec(String(sku || '')); return m ? parseInt(m[1], 10) : 0; }
  var PACKS = (CFG.packs || []).map(function (v) {
    return { id: v.id, qty: skuQty(v.sku), cents: parseInt(v.price, 10) || 0, title: v.title, sku: v.sku };
  }).filter(function (p) { return p.id && p.qty && p.cents; })
    .sort(function (a, b) { return a.qty - b.qty; });
  var OK = !!(CFG.publishedAt && PACKS.length);
  var BADGE = { 12: 'STARTER', 120: 'MOST POPULAR', 600: 'BEST VALUE', 960: 'SHOP' };

  /* Liquid-embedded prices are market-converted; label them in the buyer's
     currency, not a hardcoded dollar (the $142-for-24-seals lesson, 2026-08-28) */
  function fmtMoney(x) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    if (cur === 'USD') return '$' + x.toFixed(2);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(x); }
    catch (e) { return '$' + x.toFixed(2); }
  }
  function money(c) { return fmtMoney(c / 100); }
  function per(p) { return fmtMoney(p.cents / p.qty / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── rush: the Skip the Production Line ladder, cart-wide ──
     Mirrors sv-builder.js exactly (same variant-title join, same pure plan).
     If the two ever disagree the two builders would charge different fees for
     the same order — change BOTH or neither. */
  var RUSH_LADDER = [
    [12, '12-99 labels'], [100, '100-249 labels'], [250, '250-499 labels'],
    [500, '500-999 labels'], [1000, '1,000-2,499 labels'], [2500, '2,500-4,999 labels'],
    [5000, '5,000-9,999 labels'], [10000, '10,000+ labels']];
  var RUSH = { tiers: [] };
  (function () {
    var vs = (CFG.rush || {}).variants || [];
    RUSH.tiers = RUSH_LADDER.map(function (t) {
      var v = vs.filter(function (x) { return x.title === t[1]; })[0];
      return v ? { min: t[0], id: v.id, cents: parseInt(v.price, 10), label: t[1] } : null;
    }).filter(Boolean);
    RUSH.ok = !!((CFG.rush || {}).publishedAt && RUSH.tiers.length === RUSH_LADDER.length);
  })();
  function rushTierFor(n) {
    for (var i = RUSH.tiers.length - 1; i >= 0; i--) if (n >= RUSH.tiers[i].min) return RUSH.tiers[i];
    return RUSH.tiers[0];
  }
  function cartLabelsOf(cart) {
    return (cart.items || []).reduce(function (n, it) {
      var sku = String(it.sku || '').toUpperCase();
      if (sku.indexOf('SVN-PACK') === 0 || sku.indexOf('SVN-WIDE') === 0) return n + it.quantity * 12;
      var tq = skuQty(sku);
      if (tq) return n + tq * it.quantity;
      /* Lost & Found contact labels (SVN-LOST-12-<MAT> standard die,
         SVN-LOSTW-12-<MAT> large die) — twelve labels a pack off the same
         two presses, so the rush ladder counts them with everything else.
         One of FOUR counters that must agree: ss-cart.js rushLabelsOf,
         sv-builder.js cartSealsOf, lt-builder.js and this one. */
      var lf = /^SVN-LOST(W?)-(\d+)(?:-|$)/.exec(sku);
      if (lf) return n + (parseInt(lf[2], 10) || 12) * it.quantity;
      return n;
    }, 0);
  }
  function cartRushLine(cart) {
    return (cart.items || []).filter(function (it) {
      return String(it.sku || '').toUpperCase() === 'PRIORITY-PROD' ||
             (it.properties && it.properties._ss_rush);
    })[0] || null;
  }
  function rushPlan(cart, added, want) {
    var line = cartRushLine(cart);
    var labels = cartLabelsOf(cart) + added;
    var tier = ((want || !!line) && RUSH.ok) ? rushTierFor(labels) : null;
    var stale = !!line && (!tier || String(line.variant_id) !== String(tier.id));
    return { line: line, labels: labels, tier: tier, stale: stale,
             add: !!tier && (stale || !line) };
  }
  function rushLine(tier, labels) {
    return { id: tier.id, quantity: 1, properties: {
      'Service': 'Skip the Production Line — priority production, not shipping speed',
      'Order size': tier.label, 'Labels in order': String(labels),
      'Refund': 'Refunded in full if we do not move your order ahead of the queue',
      '_ss_rush': '1' } };
  }

  /* ── state ── */
  var CAP = { name: 28, year: 4, set: 24, number: 12, extra: 24, brand: 22, grade: 14, gl: 12, tid: 16, sub: 4 };
  var MAX_DESIGNS = 40;   /* line-item properties have a size budget; 40 unique
                             designs x ~250 bytes stays far inside it, and qty
                             covers everything beyond */
  function blankTag(from) {
    var t = { name: '', year: '', set: '', number: '', extra: '', tid: '',
              grade: '', gl: '', sub: null, brand: '', lo: '',
              layout: 'classic', bg: 'holo', q: 1 };
    if (from) { t.brand = from.brand; t.lo = from.lo; t._data = from._data;
                t.layout = from.layout; t.bg = from.bg; }
    return t;
  }
  var st = { step: 1, packIdx: 2, rush: false, tags: [blankTag()], cur: 0, editKey: '' };
  for (var pi = 0; pi < PACKS.length; pi++) if (PACKS[pi].qty === 12) st.packIdx = pi;
  try {
    var _pq = parseInt(new URLSearchParams(location.search).get('pack') || '', 10);
    if (_pq) for (var pj = 0; pj < PACKS.length; pj++)
      if (PACKS[pj].qty === _pq) { st.packIdx = pj; st._pinPack = true; }
  } catch (_) {}

  function cur() { return st.tags[st.cur] || st.tags[0]; }
  function pack() { return PACKS[st.packIdx] || PACKS[0]; }
  function assigned() { return st.tags.reduce(function (n, t) { return n + (t.q || 0); }, 0); }

  /* draft persistence — dataURLs deliberately stripped (they are session
     preview sugar; the CDN URL is what survives and what production reads) */
  function saveDraft() {
    try {
      var slim = JSON.parse(JSON.stringify(st, function (k, v) {
        return (k === '_data' || k === '_upP') ? undefined : v;
      }));
      localStorage.setItem('gt_draft', JSON.stringify(slim));
    } catch (_) {}
  }
  function loadDraft() {
    try {
      var ed = localStorage.getItem('gt_edit');
      if (ed) {
        localStorage.removeItem('gt_edit');
        var e = JSON.parse(ed);
        if (e && e.gt && e.gt.tags && e.gt.tags.length) {
          st.tags = e.gt.tags.map(fromCompact);
          st.editKey = e.key || '';
          st.rush = !!e.rush;
          for (var i = 0; i < PACKS.length; i++) if (String(PACKS[i].id) === String(e.variantId)) st.packIdx = i;
          st.step = 5;                      /* land on the pack screen, everything restored */
          return;
        }
      }
      var d = localStorage.getItem('gt_draft');
      if (d) {
        var s = JSON.parse(d);
        if (s && s.tags && s.tags.length) {
          st.tags = s.tags; st.step = s.step || 1;
          /* clamp: a draft saved against the old 9-pack lineup can index
             past the new array — fall back to the starter pack */
          if (!st._pinPack && PACKS[s.packIdx]) st.packIdx = s.packIdx;
          st.rush = !!s.rush; st.cur = Math.min(s.cur || 0, s.tags.length - 1);
          st.editKey = s.editKey || '';
        }
      }
    } catch (_) {}
  }

  /* compact wire form <-> working form (cart property `_gt`) */
  function toCompact(t) {
    var o = { la: t.layout, bg: t.bg, n: t.name, q: t.q };
    if (t.year) o.y = t.year; if (t.set) o.s = t.set; if (t.number) o.no = t.number;
    if (t.extra) o.x = t.extra; if (t.tid) o.ti = t.tid;
    if (t.grade) o.g = t.grade; if (t.gl) o.gl = t.gl;
    if (t.brand) o.b = t.brand;
    if (t.lo) o.lo = t.lo;
    if (t.sub) o.sub = t.sub;
    return o;
  }
  function fromCompact(o) {
    return { layout: o.la || 'classic', bg: o.bg || 'holo', name: o.n || '', year: o.y || '',
             set: o.s || '', number: o.no || '', extra: o.x || '', grade: o.g || '',
             gl: o.gl || '', tid: o.ti || '', sub: o.sub || null,
             brand: o.b || '', lo: o.lo || '', q: o.q || 1 };
  }
  function cfgOf(t) {
    return { layout: t.layout, bg: t.bg, name: t.name, year: t.year, set: t.set,
             number: t.number, extra: t.extra, grade: t.grade, gl: t.gl, tid: t.tid,
             sub: t.sub, brand: t.brand, logo: t._data || t.lo || '' };
  }

  /* ── DOM helpers ── */
  function $(id) { return document.getElementById(id); }
  function h(html) { var d = document.createElement('div'); d.innerHTML = html; return d; }

  var STEPS = ['Card', 'Grade', 'Brand', 'Design', 'Pack', 'Review'];

  function render() {
    if (!OK) {
      $('gtb-body').innerHTML = '<p style="color:var(--muted)">The grading sticker product is ' +
        'not available right now — please check back shortly.</p>';
      $('gtb-bar').style.display = 'none';
      return;
    }
    var lg = document.getElementById('gtb-legal-top');
    if (lg) lg.style.display = (st.step === 1 || st.step === 6) ? '' : 'none';
    renderProg(); renderPreview(); renderBody(); renderPackState(); renderFlowNav(); renderBar(); saveDraft();
  }

  /* what the pack already holds, visible while building the NEXT tag — the
     state that proves nothing was lost */
  function renderPackState() {
    var b = $('gtb-body');
    if (!b) return;
    var html = '';
    if (st.step === 1 && st._saved) {
      html += '<div class="gtb-saved">✓ <b>' + esc(st._saved.n) +
        (st._saved.g ? ' — ' + esc(st._saved.g) : '') + '</b> ' +
        (st._saved.dup ? 'duplicated into' : 'saved to') +
        ' your pack. Now build the next sticker.</div>';
    }
    if (st.step < 5 && st.tags.length > 1) {
      var named = st.tags.filter(function (t) { return t.name; }).length;
      html += '<button type="button" class="gtb-packchip" id="gt-viewpack">' +
        '<b>' + named + ' design' + (named === 1 ? '' : 's') + ' in your pack</b>' +
        '<span>' + assigned() + ' / ' + pack().qty + ' stickers · View pack →</span></button>';
    }
    if (html) {
      b.insertAdjacentHTML('afterbegin', html);
      var vp = $('gt-viewpack');
      if (vp) vp.onclick = function () { st.step = 5; render(); window.scrollTo({ top: 0 }); };
    }
  }

  /* IN-FLOW Back/Continue at the end of every step (the mock's own shape).
     The sticky bar mirrors it, but this one cannot be hidden by anything a
     phone does to fixed elements — iOS toolbar overlap, consent banners,
     backdrop-filter paint bugs. The customer can ALWAYS scroll to it. */
  function renderFlowNav() {
    var b = $('gtb-body');
    if (!b) return;
    var wrap = document.createElement('div');
    wrap.className = 'gtb-flownav';
    if (st.step > 1) {
      var back = document.createElement('button');
      back.type = 'button'; back.className = 'gtb-back';
      back.textContent = 'Back';
      back.onclick = goBack;
      wrap.appendChild(back);
    }
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'gtb-next';
    if (st.step === 6) {
      next.textContent = 'ADD TO CART — ' + money(pack().cents);
      /* Under-assigning no longer blocks (owner 2026-08-14): placeOrder()
         tops the pack up to its paid quantity, so the only states left that
         can stop the button are an empty pack and an over-full one. */
      next.disabled = assigned() < 1 || assigned() > pack().qty;
    } else {
      next.textContent = 'CONTINUE TO ' + STEPS[st.step].toUpperCase() + ' →';
    }
    next.onclick = goNext;
    wrap.appendChild(next);
    b.appendChild(wrap);
    /* two identical CTAs at once read as a bug — the sticky bar steps
       aside whenever the in-flow pair is actually on screen */
    try {
      if (window._gtbIO) window._gtbIO.disconnect();
      var bar = $('gtb-bar');
      if (bar && 'IntersectionObserver' in window) {
        window._gtbIO = new IntersectionObserver(function (en) {
          bar.classList.toggle('gtb-bar--off', !!(en[0] && en[0].isIntersecting));
        }, { rootMargin: '0px 0px -56px 0px' });
        window._gtbIO.observe(wrap);
      }
    } catch (_) {}
  }

  function goBack() {
    if (st.step > 1) { st.step--; render(); window.scrollTo({ top: 0 }); }
  }
  function goNext() {
    if (st.step === 6) return placeOrder();
    if (!validateStep()) return;
    st._saved = null;               /* the banner earned its one screen */
    st.step++; render(); window.scrollTo({ top: 0 });
  }

  function renderProg() {
    var o = [];
    for (var i = 0; i < 6; i++) {
      var cls = i + 1 === st.step ? 'on' : (i + 1 < st.step ? 'done' : '');
      o.push('<span class="' + cls + '"><i class="' + cls + '">' +
        (i + 1 < st.step ? '✓' : (i + 1)) + '</i><b>' + STEPS[i] + '</b></span>');
    }
    $('gtb-prog').innerHTML = o.join('');
  }

  var _pvT = null;
  function renderPreview() {
    /* debounced: mounting is cheap but a fast typist repaints every keystroke,
       and the fit pass forces layout each time */
    clearTimeout(_pvT);
    _pvT = setTimeout(function () {
      var host = $('gtb-pv');
      if (!host || !window.GT) return;
      GT.mount(host, cfgOf(cur()));
    }, 90);
  }

  function renderBody() {
    var b = $('gtb-body');
    if (st.step === 1) return step1(b);
    if (st.step === 2) return step2(b);
    if (st.step === 3) return step3(b);
    if (st.step === 4) return step4(b);
    if (st.step === 5) return step5(b);
    if (st.step === 6) return step6(b);
  }

  function field(id, label, val, opts) {
    opts = opts || {};
    return '<div class="gtb-f' + (opts.lead ? ' gtb-lead' : '') + '">' +
      '<label for="' + id + '">' + label +
      (opts.req ? '' : ' <i>— optional</i>') + '</label>' +
      '<input type="text" id="' + id + '" value="' + esc(val) + '"' +
      ' maxlength="' + (opts.cap || 40) + '"' +
      (opts.num ? ' inputmode="numeric" pattern="[0-9]*"' : '') +
      (opts.ph ? ' placeholder="' + esc(opts.ph) + '"' : '') +
      ' autocomplete="off">' +
      '<p class="gtb-err" id="' + id + '-err"></p></div>';
  }
  function bindField(id, key, cap) {
    var el = $(id);
    if (!el) return;
    el.oninput = function () {
      cur()[key] = el.value.slice(0, cap);
      renderPreview(); saveDraft();
    };
    /* the sticky bar must never sit on a focused input */
    el.onfocus = function () {
      setTimeout(function () { try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {} }, 250);
    };
  }
  function err(id, msg) {
    var e = $(id + '-err');
    if (e) { e.textContent = msg || ''; e.className = 'gtb-err' + (msg ? ' on' : ''); }
  }

  /* ── STEP 1: CARD ── */
  function step1(b) {
    var t = cur();
    var more = !!(t.extra) || st._more;
    b.innerHTML =
      '<h2 class="gtb-st">Card details</h2>' +
      field('f-name', 'CARD NAME', t.name, { req: 1, lead: 1, cap: CAP.name, ph: 'Charizard' }) +
      field('f-year', 'YEAR', t.year, { cap: CAP.year, num: 1, ph: '1999' }) +
      field('f-set', 'SET / SERIES', t.set, { cap: CAP.set, ph: 'Base Set' }) +
      field('f-number', 'CARD NUMBER', t.number, { cap: CAP.number, ph: '4/102' }) +
      (more
        ? field('f-extra', 'VARIETY / EXTRA LINE', t.extra, { cap: CAP.extra, ph: '1st Edition' }) +
          field('f-tid', 'STICKER NUMBER', t.tid, { cap: CAP.tid, ph: 'SS24-0001234 or 1/12' })
        : '<button type="button" class="gtb-more" id="f-more">+ ADD MORE DETAILS</button>');
    bindField('f-name', 'name', CAP.name);
    bindField('f-year', 'year', CAP.year);
    bindField('f-set', 'set', CAP.set);
    bindField('f-number', 'number', CAP.number);
    if (more) { bindField('f-extra', 'extra', CAP.extra); bindField('f-tid', 'tid', CAP.tid); }
    else $('f-more').onclick = function () { st._more = true; render(); };
  }

  /* ── STEP 2: GRADE ── */
  var GRADES = ['10', '9.5', '9', '8.5', '8', '7.5', '7', '6', '5', '4', '3'];
  var GL_WORDS = ['GEM MINT', 'MINT', 'NM-MT', 'NEAR MINT', 'AUTHENTIC'];
  function step2(b) {
    var t = cur();
    var isCustom = t.grade && GRADES.indexOf(t.grade) === -1;
    var o = ['<h2 class="gtb-st">Select grade</h2>', '<div class="gtb-grades">'];
    GRADES.forEach(function (g) {
      o.push('<button type="button" class="gtb-g' + (t.grade === g ? ' on' : '') +
        '" data-g="' + g + '" aria-pressed="' + (t.grade === g) + '">' + g + '</button>');
    });
    o.push('<button type="button" class="gtb-g' + (isCustom ? ' on' : '') + '" data-g="_c">CUSTOM</button>');
    o.push('</div>');
    if (isCustom || st._customG) {
      o.push(field('f-grade', 'YOUR OWN WORDING', isCustom ? t.grade : '',
        { req: 1, cap: CAP.grade, ph: 'GEM MINT / AUTHENTIC / RAW' }));
      o.push('<p class="gtb-legal">Your personal wording, displayed as your grade. Not a ' +
        'third-party certification.</p>');
    }
    /* wording under a numeric grade — the mock's "9.5 / GEM MINT" shape */
    if (/^[0-9]+(\.[0-9])?$/.test(t.grade)) {
      o.push('<div class="gtb-f" style="margin-top:14px"><label>WORDING UNDER THE GRADE' +
        ' <i>— optional</i></label><div class="gtb-glrow">');
      GL_WORDS.forEach(function (w) {
        o.push('<button type="button" class="gtb-gl' + (t.gl === w ? ' on' : '') +
          '" data-gl="' + w + '">' + w + '</button>');
      });
      o.push('<button type="button" class="gtb-gl' +
        (t.gl && GL_WORDS.indexOf(t.gl) === -1 ? ' on' : '') + '" data-gl="_c">OWN…</button>');
      o.push('</div>');
      if (st._customGl || (t.gl && GL_WORDS.indexOf(t.gl) === -1)) {
        o.push(field('f-gl', 'YOUR WORDING', GL_WORDS.indexOf(t.gl) === -1 ? t.gl : '',
          { cap: CAP.gl, ph: 'PERSONAL GRADE' }));
      }
      o.push('</div>');
    }
    var sub = t.sub || {};
    var on = !!t.sub;
    o.push('<div class="gtb-sub">' +
      '<label class="gtb-sub-head"><input type="checkbox" id="f-subon"' + (on ? ' checked' : '') +
      '> ADD SUBGRADES</label>');
    if (on) {
      o.push('<div class="gtb-subs">' +
        subF('f-sc', 'CENTERING', sub.c) + subF('f-scr', 'CORNERS', sub.cr) +
        subF('f-se', 'EDGES', sub.e) + subF('f-ssu', 'SURFACE', sub.su) + '</div>');
    }
    o.push('<p class="gtb-err" id="f-g-err"></p></div>');
    b.innerHTML = o.join('');
    b.querySelectorAll('.gtb-g').forEach(function (btn) {
      btn.onclick = function () {
        var g = btn.getAttribute('data-g');
        if (g === '_c') { st._customG = true; cur().grade = ''; }
        else { st._customG = false; cur().grade = g; }
        render();
      };
    });
    b.querySelectorAll('.gtb-gl').forEach(function (btn) {
      btn.onclick = function () {
        var w = btn.getAttribute('data-gl');
        if (w === '_c') { st._customGl = true; }
        else if (cur().gl === w) { cur().gl = ''; st._customGl = false; }
        else { cur().gl = w; st._customGl = false; }
        render();
      };
    });
    if ($('f-gl')) bindField('f-gl', 'gl', CAP.gl);
    if ($('f-grade')) bindField('f-grade', 'grade', CAP.grade);
    $('f-subon').onchange = function () {
      cur().sub = this.checked ? (cur().sub || { c: '', cr: '', e: '', su: '' }) : null;
      render();
    };
    [['f-sc', 'c'], ['f-scr', 'cr'], ['f-se', 'e'], ['f-ssu', 'su']].forEach(function (m) {
      var el = $(m[0]);
      if (el) el.onchange = function () {
        cur().sub[m[1]] = el.value;
        renderPreview(); saveDraft();
      };
    });
  }
  /* selectable values, not typed — 10 down to 1 in half steps */
  function subF(id, label, val) {
    var o = '<div class="gtb-f"><label for="' + id + '">' + label + '</label>' +
      '<select id="' + id + '"><option value="">–</option>';
    for (var v = 20; v >= 2; v--) {
      var g = (v / 2) % 1 === 0 ? String(v / 2) : (v / 2).toFixed(1);
      o += '<option value="' + g + '"' + (val === g ? ' selected' : '') + '>' + g + '</option>';
    }
    return o + '</select></div>';
  }

  /* ── STEP 3: BRAND ── */
  function step3(b) {
    var t = cur();
    var o = ['<h2 class="gtb-st">Brand your sticker</h2>',
             '<p class="gtb-note" style="margin:0 0 12px">Optional — leave both blank to print without branding.</p>',
             field('f-brand', 'BUSINESS / COLLECTION NAME', t.brand, { cap: CAP.brand, ph: 'Northgate Cards' })];
    o.push('<div class="gtb-f"><label>LOGO <i>— optional · PNG or JPG</i></label>');
    if (t._data || t.lo) {
      o.push('<div class="gtb-lgrow"><img src="' + esc(t._data || t.lo) + '" alt="Your logo">' +
        '<span style="font-size:13px;color:var(--muted)" id="f-lo-note">' +
        (t.lo ? 'saved' : (t._upErr ? 'upload failed — try another image' : 'saving…')) + '</span>' +
        '<span style="margin-left:auto;display:flex;gap:7px">' +
        '<button type="button" class="btn2" id="f-lo-rep">Replace</button>' +
        '<button type="button" class="btn2" id="f-lo-rm">Remove</button></span></div>');
    } else {
      o.push('<button type="button" class="gtb-up" id="f-lo-up"><em>↑</em>' +
        'Upload logo<small>PNG or JPG · max 8 MB</small></button>');
    }
    o.push('<p class="gtb-err" id="f-lo-err"></p></div>');
    o.push('<p class="gtb-legal">Your logo prints on every style except the type-only ones ' +
      '(Slash, Arc and Plate), and never overlaps your card text or grade.</p>');
    b.innerHTML = o.join('');
    bindField('f-brand', 'brand', CAP.brand);
    var up = $('f-lo-up') || $('f-lo-rep');
    if (up) up.onclick = pickLogo;
    if ($('f-lo-rm')) $('f-lo-rm').onclick = function () {
      var c = cur(); c.lo = ''; c._data = ''; c._upErr = false; render();
    };
  }
  var _inp = null;   /* pinned — Safari GC's a detached picker input */
  function pickLogo() {
    var inp = document.createElement('input');
    inp.type = 'file'; inp.accept = 'image/png,image/jpeg';
    inp.onchange = function () {
      var f = this.files[0]; _inp = null;
      if (!f) return;
      if (f.size > 8 * 1024 * 1024) { err('f-lo', 'That file is over 8 MB — export a smaller PNG.'); return; }
      var fr = new FileReader();
      fr.onload = function () {
        var t = cur();
        t._data = fr.result; t.lo = ''; t._upErr = false;
        render();
        uploadLogo(t, f.name);
      };
      fr.readAsDataURL(f);
    };
    _inp = inp; inp.click();
  }
  function uploadLogo(t, name) {
    /* same Worker relay the seal builder uses — the CDN URL is what rides the
       cart line and what Label Farm's renderer fetches at print time */
    t._upP = fetch(CFG.worker + '/upload', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name || 'logo.png', data: t._data, kind: 'logo' })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.ok && d.url) { t.lo = d.url; }
      else { t._upErr = true; }
      if (st.step === 3) render(); else saveDraft();
    }).catch(function () { t._upErr = true; if (st.step === 3) render(); });
  }

  /* ── STEP 4: DESIGN ── */
  function step4(b) {
    var t = cur();
    var _ln = (GT.LAYOUTS.filter(function (l) { return l.key === t.layout; })[0] || { name: t.layout }).name;
    var _bn = (GT.BGS.filter(function (g) { return g.key === t.bg; })[0] || { name: t.bg }).name;
    var o = ['<h2 class="gtb-st">Choose a style</h2>',
             '<p class="gtb-sel">Selected: <b>' + esc((_ln + ' · ' + _bn).toUpperCase()) + '</b></p>',
             '<div class="gtb-f"><label>LAYOUT</label><div class="gtb-lay">'];
    GT.LAYOUTS.forEach(function (l) {
      o.push('<button type="button" class="gtb-l' + (t.layout === l.key ? ' on' : '') +
        '" data-l="' + l.key + '"><span class="mini" data-mini="' + l.key + '"></span><b>' +
        l.name.toUpperCase() + '</b></button>');
    });
    o.push('</div></div>');
    o.push('<div class="gtb-f"><label>BACKGROUND / ACCENT</label><div class="gtb-bgs">');
    GT.BGS.forEach(function (g) {
      var dot = g.key === 'holo' ? 'linear-gradient(120deg,#8be0ff,#c9a6ff,#ffd6a0)' :
                g.key === 'black' ? '#04050a' : g.key === 'silver' ? '#9aa2b1' :
                g.key === 'prismatic' ? 'repeating-linear-gradient(45deg,#8be0ff 0 2px,#04050a 2px 4px)' :
                g.key === 'premium' ? 'linear-gradient(120deg,#101830,#241335)' : (g.tint || '#333');
      o.push('<button type="button" class="gtb-b' + (t.bg === g.key ? ' on' : '') +
        '" data-b="' + g.key + '"><em style="background:' + dot + '"></em>' +
        g.name.toUpperCase() + '</button>');
    });
    o.push('</div></div>');
    /* honesty over silence: two layouts carry the subgrade strip; if they
       entered subgrades and picked another, say so here rather than letting
       the strip quietly vanish from the preview */
    if (t.layout === 'price') {
      o.push('<div class="gtb-note">PRICE TAG: the right half prints <b>blank</b> - no ink, ' +
        'just the holographic stock - so you can write a price on each tag with a ' +
        'permanent marker (Sharpie). Let it dry a few seconds before handling. The card ' +
        'details get half the room, so keep long set or brand names short.</div>');
    }
    if (t.sub && !(t.layout === 'classic' || t.layout === 'subgrade')) {
      o.push('<div class="gtb-note">Subgrades print on the CLASSIC and SUBGRADE styles — ' +
        'this style shows the overall grade only.</div>');
    }
    /* same honesty for the logo: three styles are deliberately type-only */
    if ((t.lo || t._data) && (t.layout === 'slash' || t.layout === 'arc' || t.layout === 'plate')) {
      o.push('<div class="gtb-note">This style is type-only — your logo prints on the ' +
        'other styles.</div>');
    }
    o.push('<p class="gtb-legal">The printer lays no white ink — open and pale areas are the ' +
      'holographic material itself showing through. Open Holo uses that on purpose.</p>');
    b.innerHTML = o.join('');
    /* live minis: each layout card previews THIS tag in that layout */
    b.querySelectorAll('[data-mini]').forEach(function (m) {
      var k = m.getAttribute('data-mini');
      var c = cfgOf(t); c.layout = k;
      GT.mount(m, c);
    });
    b.querySelectorAll('.gtb-l').forEach(function (btn) {
      btn.onclick = function () { cur().layout = btn.getAttribute('data-l'); render(); };
    });
    b.querySelectorAll('.gtb-b').forEach(function (btn) {
      btn.onclick = function () { cur().bg = btn.getAttribute('data-b'); render(); };
    });
  }

  /* ── STEP 5: PACK + TAG MANAGEMENT ── */
  function step5(b) {
    var o = ['<h2 class="gtb-st">Choose your pack</h2>',
             '<div class="gtb-f"><div class="gtb-packs">'];
    PACKS.forEach(function (p, i) {
      o.push('<button type="button" class="gtb-pk' + (i === st.packIdx ? ' on' : '') +
        '" data-p="' + i + '"><b>' + p.qty + ' stickers</b>' +
        (BADGE[p.qty] ? '<i>' + BADGE[p.qty] + '</i>' : '') +
        '<span class="pr"><b>' + money(p.cents) + '</b><span>' + per(p) + ' each</span></span>' +
        '</button>');
    });
    o.push('</div></div>');
    o.push('<div class="gtb-f" style="margin-top:18px"><label>YOUR ' + pack().qty +
      ' STICKERS — customize every sticker individually</label><div class="gtb-tags" id="gt-list"></div>' +
      '<button type="button" class="gtb-add" id="gt-addtag">+ SAVE &amp; ADD ANOTHER DESIGN</button>' +
      '<p class="gtb-assign" id="gt-assign"></p></div>');
    if (RUSH.ok) {
      o.push('<label class="gtb-rush"><input type="checkbox" id="gt-rush"' + (st.rush ? ' checked' : '') +
        '><span><b>⚡ Skip the Production Line <span id="gt-rushp"></span></b>' +
        '<p>Move your order to priority production. The fee is based on the total label count ' +
        'across your whole order. Production speed, not shipping speed — refunded if we do ' +
        'not move you ahead of the queue.</p></span></label>');
    }
    b.innerHTML = o.join('');
    b.querySelectorAll('.gtb-pk').forEach(function (btn) {
      btn.onclick = function () { st.packIdx = parseInt(btn.getAttribute('data-p'), 10); render(); };
    });
    $('gt-addtag').onclick = function () {
      if (st.tags.length >= MAX_DESIGNS) {
        alertLine('A pack can carry up to ' + MAX_DESIGNS + ' unique designs — use quantities for the rest.');
        return;
      }
      var prev = st.tags[st.tags.length - 1];
      /* the fresh editor must SAY the old design was kept, or empty fields
         read as a wipe (owner hit exactly this) */
      st._saved = prev && prev.name ? { n: prev.name, g: prev.grade } : null;
      st.tags.push(blankTag(prev));
      st.cur = st.tags.length - 1; st.step = 1; st._more = false; render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    if ($('gt-rush')) {
      $('gt-rush').onchange = function () { st.rush = this.checked; render(); };
      paintRushPrice();
    }
    renderTagList();
  }
  function alertLine(msg) {
    var a = $('gt-assign');
    if (a) { a.textContent = msg; a.className = 'gtb-assign bad'; }
  }
  function paintRushPrice() {
    var el = $('gt-rushp');
    if (!el || !RUSH.ok) return;
    el.textContent = '— …';
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = rushTierFor(cartLabelsOf(c) + pack().qty);
        el.textContent = '— ' + money(t.cents);
      }).catch(function () {
        var t = rushTierFor(pack().qty);
        el.textContent = '— ' + money(t.cents);
      });
  }
  function renderTagList() {
    var list = $('gt-list');
    if (!list) return;
    list.innerHTML = '';
    st.tags.forEach(function (t, i) {
      var row = h('<div class="gtb-t"><div class="gtb-t-top">' +
        '<span class="th" data-th></span>' +
        '<span class="nm"><b>' + esc(t.name || 'Untitled sticker') + '</b>' +
        '<span>' + esc([t.grade ? 'Grade ' + t.grade : '', GT.metaLine(t)].filter(Boolean).join(' · ')) +
        '</span></span></div>' +
        '<div class="gtb-t-act">' +
        '<button type="button" class="btn2" data-a="edit">Edit</button>' +
        '<button type="button" class="btn2" data-a="dup">Duplicate</button>' +
        '<button type="button" class="btn2" data-a="del">Delete</button>' +
        '<span class="gtb-qty"><button type="button" data-a="minus" aria-label="Fewer">−</button>' +
        '<b>' + t.q + '</b>' +
        '<button type="button" data-a="plus" aria-label="More">+</button></span>' +
        '</div></div>').firstChild;
      GT.mount(row.querySelector('[data-th]'), cfgOf(t));
      row.querySelector('[data-a=edit]').onclick = function () {
        st.cur = i; st.step = 1; render(); window.scrollTo({ top: 0, behavior: 'smooth' });
      };
      row.querySelector('[data-a=dup]').onclick = function () {
        if (st.tags.length >= MAX_DESIGNS) { alertLine('Design limit reached — use quantities.'); return; }
        var c = JSON.parse(JSON.stringify(toCompact(t)));
        var nt = fromCompact(c); nt.q = 1; nt._data = t._data;
        st.tags.splice(i + 1, 0, nt);
        st._saved = t.name ? { n: t.name, g: t.grade, dup: true } : null;
        st.cur = i + 1; st.step = 1; st._more = false; render();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
      row.querySelector('[data-a=del]').onclick = function () {
        st.tags.splice(i, 1);
        if (!st.tags.length) st.tags = [blankTag()];
        st.cur = Math.min(st.cur, st.tags.length - 1);
        render();
      };
      row.querySelector('[data-a=minus]').onclick = function () {
        t.q = Math.max(1, (t.q || 1) - 1); render();
      };
      row.querySelector('[data-a=plus]').onclick = function () {
        var room = pack().qty - assigned();
        if (room > 0) { t.q = (t.q || 1) + 1; render(); }
        else alertLine('All ' + pack().qty + ' stickers are assigned — remove one somewhere else first, or pick a bigger pack.');
      };
      list.appendChild(row);
    });
    paintAssign();
  }
  function paintAssign() {
    var a = $('gt-assign');
    if (!a) return;
    var n = assigned(), q = pack().qty;
    a.textContent = n + ' / ' + q + ' STICKERS ASSIGNED';
    /* under is fine now — it reads as neutral, not an error, because the
       customer can cart from here either way */
    a.className = 'gtb-assign ' + (n === q ? 'ok' : (n > q ? 'bad' : ''));
    if (n < q && st.tags.length) {
      var note = document.createElement('span');
      note.style.cssText = 'display:block;font-weight:400;opacity:.75;margin-top:2px';
      note.textContent = 'The remaining ' + (q - n) + ' will go to "' +
        (st.tags[st.tags.length - 1].name || 'your last design') +
        '" unless you assign them.';
      a.appendChild(note);
    }
  }

  /* ── STEP 6: REVIEW ── */
  function step6(b) {
    var p = pack();
    var o = ['<h2 class="gtb-st">Review your stickers</h2>',
      '<div class="gtb-summary">' +
      '<div><span>STICKER SIZE</span><b>0.75\u2033 \u00d7 1.77\u2033 \u00b7 19.05 \u00d7 44.96 mm</b></div>' +
      '<div id="gt-sum-pack" role="button" tabindex="0" style="cursor:pointer">' +
      '<span>PACK SIZE</span><b>' + p.qty + ' stickers <span style="color:#b9a6ff;font-size:12px">change</span></b></div>' +
      '<div><span>TOTAL</span><b>' + money(p.cents) + '</b></div>' +
      '<div><span>DESIGNS</span><b>' + st.tags.length + '</b></div>' +
      '</div>'];
    st.tags.forEach(function (t, i) {
      o.push('<div class="gtb-rv" data-rv="' + i + '"><div class="big" data-big></div>' +
        '<p><b>' + esc([t.year, t.name].filter(Boolean).join(' ')) + '</b></p>' +
        '<p class="mut">' + esc(GT.metaLine(t)) + '</p>' +
        '<p class="mut">' + esc(t.grade ? 'Grade ' + t.grade : '') + ' · Qty ' + t.q + '</p>' +
        '<p class="gtb-err" data-rverr style="text-align:center"></p>' +
        '<button type="button" class="btn2" style="display:block;margin:8px auto 0" data-a="edit">EDIT</button></div>');
    });
    o.push('<div class="gtb-okchip' + (assigned() === p.qty ? '' : ' bad') + '">' +
      (assigned() === p.qty ? '✓ ' : '') + assigned() + ' / ' + p.qty + ' STICKERS ASSIGNED</div>');
    o.push('<div class="gtb-total">Selected pack: <b>' + p.qty + ' stickers — ' + money(p.cents) + '</b>' +
      (st.rush && RUSH.ok ? '<br><span style="font-size:13px;color:#8fb3f0">+ Skip the Production ' +
        'Line, priced on your whole order at checkout</span>' : '') + '</div>');
    /* rights agreement (owner 2026-08-11): uploaded logos print under the
       CUSTOMER'S rights — our commercial license covers our designs only.
       The tick is required by placeOrder() whenever any tag carries a logo. */
    if (st.tags.some(function (t) { return t.lo || t._data; })) {
      o.push('<label id="gt-rights-row" style="display:flex;gap:10px;align-items:flex-start;' +
        'max-width:420px;margin:14px auto 0;font-size:13px;text-align:left;cursor:pointer">' +
        '<input type="checkbox" id="gt-rights"' + (st.rightsOk ? ' checked' : '') +
        ' style="margin-top:2px;flex:none"><span><b>I own the uploaded artwork or have the ' +
        'rights holder’s approval to print it.</b><br><span style="opacity:.75">Our included ' +
        'commercial license covers Serial Seal designs only — uploaded logos print under ' +
        'your own rights.</span></span></label>');
    }
    o.push('<p class="gtb-legal" style="text-align:center;margin-top:12px">Custom collector display ' +
      'stickers. Not affiliated with or certified by any third-party grading company.</p>');
    b.innerHTML = o.join('');
    var rcb = document.getElementById('gt-rights');
    if (rcb) rcb.onchange = function () { st.rightsOk = this.checked; };
    var sp = document.getElementById('gt-sum-pack');
    if (sp) sp.onclick = function () { st.step = 5; render(); window.scrollTo({ top: 0 }); };
    b.querySelectorAll('.gtb-rv').forEach(function (card) {
      var i = parseInt(card.getAttribute('data-rv'), 10);
      GT.mount(card.querySelector('[data-big]'), cfgOf(st.tags[i]));
      card.querySelector('[data-a=edit]').onclick = function () {
        st.cur = i; st.step = 1; render(); window.scrollTo({ top: 0, behavior: 'smooth' });
      };
    });
  }

  /* ── the sticky bar ── */
  function renderBar() {
    var back = $('gtb-back'), next = $('gtb-next'), moneyEl = $('gtb-money');
    back.style.visibility = st.step === 1 ? 'hidden' : 'visible';
    if (st.step === 6) {
      moneyEl.style.display = '';
      moneyEl.textContent = money(pack().cents);
      next.textContent = 'ADD TO CART';
      /* Under-assigning no longer blocks (owner 2026-08-14): placeOrder()
         tops the pack up to its paid quantity, so the only states left that
         can stop the button are an empty pack and an over-full one. */
      next.disabled = assigned() < 1 || assigned() > pack().qty;
    } else {
      moneyEl.style.display = 'none';
      next.disabled = false;
      next.textContent = 'CONTINUE TO ' + STEPS[st.step].toUpperCase() + ' →';
    }
  }

  function validateStep() {
    if (st.step === 1) {
      var t = cur();
      if (!t.name.trim()) { err('f-name', 'Card name is required.'); $('f-name').focus(); return false; }
      err('f-name', '');
    }
    if (st.step === 2) {
      if (!cur().grade.trim()) {
        var e = $('f-g-err');
        if (e) { e.textContent = 'Pick a grade, or choose CUSTOM and type your own.'; e.className = 'gtb-err on'; }
        return false;
      }
    }
    return true;
  }

  /* every tag must render readably — refuse to sell 0.6mm type */
  function fitCheck() {
    var bad = [];
    var host = document.createElement('div');
    host.style.cssText = 'position:absolute;left:-9999px;top:0;width:450px';
    document.body.appendChild(host);
    st.tags.forEach(function (t, i) {
      var r = GT.mount(host, cfgOf(t));
      if (r.minText !== null && r.minText < GT.MIN_TEXT) {
        var lname = (GT.LAYOUTS.filter(function (l) { return l.key === t.layout; })[0] ||
          { name: t.layout }).name;
        bad.push({ i: i, msg: 'This text is too long for the ' + lname +
          ' layout — shorten it or choose another design.' });
      }
    });
    document.body.removeChild(host);
    return bad;
  }

  /* ── ADD TO CART ── */
  var _busy = false;
  function placeOrder() {
    if (_busy) return;
    var p = pack();
    if (assigned() > p.qty) {
      /* the one case still worth refusing: more tags than the pack pays for */
      st.step = 5; render();
      alertLine('That is ' + (assigned() - p.qty) + ' more than the ' + p.qty +
                '-sticker pack holds. Lower one of the counts, or pick a bigger pack.');
      return;
    }
    if (assigned() < 1) {
      st.step = 5; render();
      alertLine('Give at least one sticker a quantity.');
      return;
    }
    if (assigned() < p.qty) {
      /* TOP UP RATHER THAN BLOCK. The pack is one fixed-price line, so an
         under-assigned pack means the customer pays for tags that never get
         printed. Handing the remainder to the last design is what the manual
         "give the remaining N to ..." button did — this just stops it being a
         step they have to find before the cart will work. */
      st.tags[st.tags.length - 1].q += (p.qty - assigned());
    }
    for (var i = 0; i < st.tags.length; i++) {
      if (!st.tags[i].name.trim() || !st.tags[i].grade.trim()) {
        st.cur = i; st.step = st.tags[i].name.trim() ? 2 : 1; render();
        return;
      }
    }
    var bad = fitCheck();
    if (bad.length) {
      var card = document.querySelector('[data-rv="' + bad[0].i + '"] [data-rverr]');
      if (card) { card.textContent = bad[0].msg; card.className = 'gtb-err on'; }
      st.cur = bad[0].i;
      return;
    }
    /* uploaded logos print under the customer's rights — the order cannot
       leave without the agreement ticked (owner 2026-08-11) */
    var _hasLogoArt = st.tags.some(function (t) { return t.lo || t._data; });
    if (_hasLogoArt && !st.rightsOk) {
      st.step = 6; render();
      alertLine('Please confirm you have the rights to your uploaded artwork — tick the box above the legal line.');
      var rr = document.getElementById('gt-rights-row');
      if (rr) rr.scrollIntoView({ block: 'center' });
      return;
    }
    /* wait for any logo still uploading — the URL is the production artwork */
    var pending = [];
    st.tags.forEach(function (t) { if (t._upP && !t.lo && !t._upErr) pending.push(t._upP); });
    var next = $('gtb-next');
    _busy = true; next.textContent = pending.length ? 'Saving your logo…' : 'Adding…';
    Promise.all(pending).then(function () {
      var compact = { v: 1, tags: st.tags.map(toCompact) };
      var props = {
        'Pack': p.qty + ' stickers',
        'Designs': String(st.tags.length),
        '_gt_order': '1',
        '_gt_count': String(p.qty),
        '_gt': JSON.stringify(compact),
        /* 'agreed' is only writable because placeOrder refused to run while
           a logo was present and the rights box unticked */
        '_rights_ack': _hasLogoArt ? 'agreed' : ''
      };
      st.tags.slice(0, 8).forEach(function (t, i) {
        props['Design ' + (i + 1)] = [t.year, t.name].filter(Boolean).join(' ') +
          (t.grade ? ' — ' + t.grade : '') + ' × ' + t.q;
      });
      if (st.tags.length > 8) props['Design 9+'] = (st.tags.length - 8) + ' more designs';
      var missing = st.tags.some(function (t) { return t._upErr || (t._data && !t.lo); });
      if (missing) props['Logo note'] = 'upload failed — we will email you for the file';

      var pre = st.editKey
        ? fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: st.editKey, quantity: 0 })
          }).catch(function () {})
        : Promise.resolve();

      return pre.then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; });
      }).then(function (cart) {
        var plan = rushPlan(cart, p.qty, st.rush);
        var items = [{ id: p.id, quantity: 1, properties: props }];
        var pre2 = plan.stale && plan.line
          ? fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: plan.line.key, quantity: 0 })
            }).catch(function () {})
          : Promise.resolve();
        return pre2.then(function () {
          if (plan.add) items.push(rushLine(plan.tier, plan.labels));
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        try { localStorage.removeItem('gt_draft'); } catch (_) {}
        location.href = '/cart';
      });
    }).catch(function () {
      _busy = false;
      next.textContent = 'ADD TO CART';
      alertLine('Could not add to cart — please try again.');
      render();
    });
  }

  /* ── expand modal ── */
  function expand() {
    var m = h('<div class="gtb-modal"><div class="box"><div data-big></div>' +
      '<button type="button" class="close">Close</button></div></div>').firstChild;
    GT.mount(m.querySelector('[data-big]'), cfgOf(cur()));
    m.querySelector('.close').onclick = function () { m.remove(); };
    m.onclick = function (e) { if (e.target === m) m.remove(); };
    document.body.appendChild(m);
  }

  /* ── boot ── */
  function boot() {
    loadDraft();
    $('gtb-back').onclick = goBack;
    $('gtb-next').onclick = goNext;
    $('gtb-expand').onclick = expand;
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* the debug/test handle. sv-builder.js runs unwrapped so every check in
     tools/ can read its state directly; this file is an IIFE, so the same
     capability is granted deliberately and narrowly. LIVE REFERENCES — st is
     the actual state object, not a copy. */
  window.GTB = { st: st, PACKS: PACKS, RUSH: RUSH, rushPlan: rushPlan, render: render };
})();
